<template>
  <div class="default-layout">
    <overlay v-if="overlayActive" />
    <loader />
    <div id="viewport" class="w-100 relative viewport-wrapper">
      <main-header :cart-icon="false" />
      <section class="flex-full" :key="$route.meta.layout">
        <slot />
      </section>
      <main-footer />
      <notification />
      <sign-up />
      <cookie-notification />
      <offline-badge />
      <order-confirmation :orders-data="ordersData" v-if="loadOrderConfirmation" />
    </div>
    <vue-progress-bar />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import MainMenu from 'theme/components/core/blocks/Header/MainMenu.vue'
  import MainHeader from 'theme/components/core/blocks/Header/Header.vue'
  import MainFooter from 'theme/components/theme/blocks/Footer/Footer.vue'
  import Overlay from 'theme/components/core/Overlay.vue'
  import Loader from 'theme/components/core/Loader.vue'
  import Notification from 'theme/components/core/Notification.vue'
  import SignUp from 'theme/components/core/blocks/Auth/SignUp.vue'
  import CookieNotification from 'theme/components/core/CookieNotification.vue'
  import OfflineBadge from 'theme/components/core/OfflineBadge.vue'
  import Head from 'theme/head'

  const OrderConfirmation = () => import(/* webpackChunkName: "vsf-order-confirmation" */ 'theme/components/core/blocks/Checkout/OrderConfirmation.vue')

  export default {
    data () {
      return {
        loadStoreModal: false,
        loadOrderConfirmation: false,
        ordersData: [],
      }
    },
    computed: {
      ...mapState({
        overlayActive: state => state.ui.overlay,
      }),
      setRootName(){
        return this.$route.name
      },
      rootHome(){
        return this.setRootName === 'home'
      }
    },
    methods: {
      onOrderConfirmation (payload) {
        this.loadOrderConfirmation = true
        this.ordersData = payload
        this.$bus.$emit('modal-show', 'modal-order-confirmation')
      },
      goToStoredRoadAfterLogin () {
        if (localStorage.getItem('redirect')) {
          location.replace(localStorage.getItem('redirect'));
          localStorage.removeItem('redirect');
        }
      }
    },
    beforeMount () {
      // Progress bar on top of the page
      this.$router.beforeEach((to, from, next) => {
        this.$Progress.start()
        this.$Progress.increase(40)
        next()
      })
      this.$router.afterEach((to, from) => {
        this.$Progress.finish()
      })
      this.$bus.$on('offline-order-confirmation', this.onOrderConfirmation)
      this.$bus.$on('success-authenticate', this.goToStoredRoadAfterLogin)
    },
    beforeDestroy () {
      this.$bus.$off('offline-order-confirmation', this.onOrderConfirmation)
      this.$bus.$off('success-authenticate', this.goToStoredRoadAfterLogin)
    },
    metaInfo: Head,
    components: {
      MainMenu,
      MainHeader,
      MainFooter,
      Overlay,
      Loader,
      Notification,
      SignUp,
      CookieNotification,
      OfflineBadge,
      OrderConfirmation
    }
  }
</script>

<style lang="scss" src="theme/css/main.scss"></style>
<style lang="scss" scoped>
  .viewport-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
</style>

<style lang="scss">
  ._wrapper {
    flex: 1 1 auto;
  }
</style>
